import { ButtonModule } from './../button/button.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InsuranceSuccessfulDialogComponent } from './components/insurance-successful-dialog/insurance-successful-dialog.component';
import { CloseBtnModule } from '../close-btn/close-btn.module';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [InsuranceSuccessfulDialogComponent],
  imports: [
    CommonModule,
    ButtonModule,
    CloseBtnModule,
    MatDialogModule,
    MatButtonModule
  ],
  exports: [InsuranceSuccessfulDialogComponent]
})
export class InsuranceSuccessfulDialogModule { }
